import { Box, IconButton, List, ListItem, Text } from "@chakra-ui/react";
import React from "react";
import { IoLogOutOutline } from "react-icons/io5";

const Config = (props) => {    
    return(
        <Box p='4'>
            <List>
                <ListItem display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                    <Text>Sair</Text>
                    <IconButton size='lg' icon={<IoLogOutOutline/>} borderRadius='50%' onClick={() => {props.logout()}}/>
                </ListItem>
            </List>
        </Box>
    );
};

export default Config;